import Vue from 'vue'
import VueRouter from 'vue-router'

import VueAnalytics from 'vue-analytics'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    beforeEnter(to, from, next) {
      window.location.href = 'https://www.sinarmasmining.com'
    },
  },
  {
    path: '/landingpage/:session',
    component: () => import('../views/LandingPage/LandingPage.vue'),
    children: [
      {
        path: '',
        component: () => import('../views/LandingPage/Instruction.vue'),
      },
      {
        path: 'profil',
        component: () => import('../views/LandingPage/Profil.vue'),
      },
      {
        path: 'profilbu',
        component: () => import('../views/LandingPage/ProfilBU.vue'),
      },
      {
        path: 'alamat',
        component: () => import('../views/LandingPage/Alamat.vue'),
      },
      // {
      //   path: 'alamatbu',
      //   component: () => import('../views/LandingPage/AlamatBU.vue')
      // },
      {
        path: 'bank',
        component: () => import('../views/LandingPage/Bank.vue'),
      },
      // {
      //   path: 'bankbu',
      //   component: () => import('../views/LandingPage/BankBU.vue')
      // },
      {
        path: 'afiliasi',
        component: () => import('../views/LandingPage/Afiliasi.vue'),
      },
      {
        path: 'legalitas',
        component: () => import('../views/LandingPage/Legalitas.vue'),
      },
      {
        path: 'legalitasbu',
        component: () => import('../views/LandingPage/LegalitasBU.vue'),
      },
      {
        path: 'selesai',
        component: () => import('../views/LandingPage/Selesai.vue'),
      },
    ],
  },
  {
    path: '/review-landing-page/:session',
    component: () => import('../views/LandingPage/LandingPage.vue'),
  },
  {
    path: '/review-from-landing-page/:id',
    component: () => import('../views/LandingPage/LandingPage.vue'),
  },
  {
    path: '/pdf/pakta-integritas',
    component: () => import('../views/PDF/PaktaIntegritas.vue'),
  },
  {
    path: '/pdf/form-vendor-bu',
    component: () => import('../views/PDF/VendorBadanUsaha.vue'),
  },
  {
    path: '/pdf/form-vendor-perorangan',
    component: () => import('../views/PDF/VendorPerorangan.vue'),
  },
  {
    path: '/pdf/surat-pernyataan-non-pkp',
    component: () => import('../views/PDF/SuratPernyataanNonPKP.vue'),
  },
  {
    path: '/pdf/komitmen-keselamatan-tambang',
    component: () => import('../views/PDF/KomitmenKeselamatanTambang.vue'),
  },
  {
    path: '/pdf/k3l-vendor/:token',
    component: () => import('../views/PDF/DocumentK3L.vue'),
  },
  {
    path: '/pdf/kplh-vendor/:token',
    component: () => import('../views/PDF/DocumentKPLH.vue'),
  },

  {
    path: '/k3l-landingpage/:session',
    component: () => import('../views/K3L/index.vue'),
  },
  {
    path: '/k3l-landingpage-sipm/:id/:user',
    component: () => import('../views/K3L/sipm-view.vue'),
  },
  {
    path: '/k3l-assessor-landingpage/:id/:user',
    component: () => import('../views/K3L-Assessor/index-assessor.vue'),
  },
  // {
  //   path: '/k3l-assessor-landingpage',
  //   component: () => import('../views/K3L-Assessor/index-assessor.vue'),
  // },
  {
    path: '/k3l-validation-hoc/:id/:user',
    component: () => import('../views/K3L-Assessor/index-hoc.vue'),
  },

  {
    path: '/kplh-landingpage/:session',
    component: () => import('../views/KPLH/index.vue'),
  },
  {
    path: '/kplh-sipm-validation/:id/:user',
    component: () => import('../views/KPLH/index-sipm.vue'),
  },
  {
    path: '/kplh-hse-validation/:id/:user',
    component: () => import('../views/KPLH-Assessor/index.vue'),
  },
  {
    path: '/kplh-head-validation/:id/:user',
    component: () => import('../views/KPLH-Assessor/index-head.vue'),
  },
  {
    path: '/kplh-view/:id/:user',
    component: () => import('../views/KPLH-Assessor/index-view.vue'),
  },
  {
    path: '/kplh-assessor-landingpage/:id/:user',
    component: () => import('../views/KPLH-Assessor/index.vue'),
  },
  {
    path: '/pra-legal/:session',
    component: () => import('../views/LandingPage/LandingPage.vue')
  },
  {
    path: '/pra-legal-sipm/',
    component: () => import('../views/Pra-Legal-Sipm/LandingPage.vue')
  }
]

const router = new VueRouter({
  routes,
})

Vue.use(VueAnalytics, {
  id: 'UA-115628282-10',
  router,
})

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  if (!subsequentMiddleware) return context.next

  return (...parameters) => {
    context.next(...parameters)
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]

    const context = {
      from,
      next,
      router,
      to,
    }
    const nextMiddleware = nextFactory(context, middleware, 1)

    return middleware[0]({ ...context, next: nextMiddleware })
  }

  return next()
})

export default router
